import React from 'react';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { TestimonialsSection } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { ProductSection } from './components/ProductSection';
import { BonusSection } from './components/BonusSection';
import { PricingSection } from './components/PricingSection';
import { ResetSection } from './components/ResetSection';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { CostTable } from './components/CostTable';
import { Footer } from './components/Footer';
import { SocialProofPopup } from './components/SocialProofPopup';
export function App() {
  return <div className="min-h-screen bg-brand-dark text-white font-sans selection:bg-brand-light selection:text-white" data-id="element-0">
      <SocialProofPopup data-id="element-1" />
      <Hero data-id="element-2" />
      <StatsBar data-id="element-3" />
      <TestimonialsSection data-id="element-4" />
      <PainPoints data-id="element-5" />
      <ProductSection data-id="element-6" />
      <BonusSection data-id="element-7" />
      <PricingSection data-id="element-8" />
      <ResetSection data-id="element-9" />

      {/* More Testimonials before Guarantee */}
      <section className="py-12 md:py-20 bg-brand-dark border-t border-gray-800" data-id="element-10">
        <div className="container mx-auto px-4" data-id="element-11">
          <div className="text-center mb-6 md:mb-12" data-id="element-12">
            <h2 className="text-2xl md:text-3xl font-bold text-brand-light font-[Poppins,_sans-serif]" data-id="element-13">
              ❤️ MÁS MUJERES QUE YA LO TIENEN
            </h2>
          </div>
          <div className="flex flex-col gap-6 md:grid md:grid-cols-2 md:gap-6 max-w-5xl mx-auto" data-id="element-14">
            {[{
            initials: 'MG',
            name: 'María G.',
            location: '📍 Buenos Aires | Sistema Escudo Gástrico™',
            quote: '"7 años con omeprazol. Al mes del sistema dormí de corrido. Al mes y medio hablé con mi médico sobre reducir la dosis. Nadie me había dado algo tan concreto."'
          }, {
            initials: 'LP',
            name: 'Laura P.',
            location: '📍 Córdoba | Sistema Escudo Gástrico™',
            quote: '"El Tomo 3 cambió mis noches. La posición lateral izquierda con la cabecera elevada fue inmediata. Primera semana ya notaba la diferencia al despertar."'
          }, {
            initials: 'RM',
            name: 'Rosa M.',
            location: '📍 Rosario | Sistema + Reset Anti-Inflamatorio',
            quote: '"La tos crónica que tenía hace 3 años desapareció a las 2 semanas del Bono 4. Nadie me había dicho que venía del estómago."'
          }, {
            initials: 'CP',
            name: 'Claudia P.',
            location: '📍 Mendoza | Sistema + Reset Anti-Inflamatorio',
            quote: '"El Reset me sacó 4 cm de cintura en 21 días sin hacer dieta. Era la inflamación que nadie me había diagnosticado."'
          }].map((t, i) => <div key={i} className="flex flex-col" data-id="element-15">
                <div className="flex items-center gap-3 mb-2" data-id="element-16">
                  <div className="w-10 h-10 rounded-full bg-brand-dark border-2 border-brand-green/40 flex items-center justify-center text-brand-light font-bold text-sm shrink-0" data-id="element-17">
                    {t.initials}
                  </div>
                  <div data-id="element-18">
                    <div className="text-yellow-400 text-sm leading-none mb-0.5" data-id="element-19">
                      ★★★★★
                    </div>
                    <div className="font-bold text-white text-sm" data-id="element-20">{t.name}</div>
                    <div className="text-xs text-gray-400" data-id="element-21">{t.location}</div>
                  </div>
                </div>
                <p className="text-gray-300 italic text-sm leading-relaxed pl-0" data-id="element-22">
                  {t.quote}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      <Guarantee data-id="element-23" />
      <FAQ data-id="element-24" />
      <CostTable data-id="element-25" />

      {/* Final CTA Section (Reusing Pricing) */}
      <div className="bg-brand-black border-t border-brand-green/20" data-id="element-26">
        <PricingSection data-id="element-27" />
      </div>

      <Footer data-id="element-28" />
    </div>;
}